import angular from 'angular';
import { MovimentacoesDetalheDrawerController } from './movimentacoes-detalhe-drawer.controller';

export class MovimentacoesDetalheDrawerComponent implements angular.IComponentOptions {
    static selector = 'movimentacoesDetalheDrawer';
    static controller = MovimentacoesDetalheDrawerController;
    static template = require('!!html-loader!./movimentacoes-detalhe-drawer.component.html');
    static bindings = {
        opened: '<',
        movimentacaoId: '<',
        selectedPeriod: '<',
        canManage: '<',
        workflowEnabled: '<',
        onClose: '&?',
        onChanged: '&?'
    };
}
